<!-- Free Form Style Form -->
@if (freeFormStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="freeFormStyleForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.path">
      </h4>
      <!-- Draw -->
      <button medsurf-design-input-button [id]="'free_form_redraw'"
        [label]="'global.path_redraw' | translate"
        [class]="'mb-4'"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.EDIT"
      (click)="drawFreeForm()"></button>
      <!-- Smooth -->
      <medsurf-design-form-control-input-switch [control]="freeFormStyleForm.controls.smooth"
        [class]="'w-full'"
        [label]="'global.path_smooth'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
      <!-- Close Path -->
      <medsurf-design-form-control-input-switch [control]="freeFormStyleForm.controls.closePath"
        [class]="'w-full'"
        [label]="'global.path_close'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
      <!-- Smooth Factor -->
      <medsurf-design-form-control-input-slider [hidden]="freeFormStyleForm.value.smooth === false"
        [control]="freeFormStyleForm.controls.smoothFactor"
        [class]="'w-full'"
        [max]="50"
        [isPercentage]="true"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
    </div>
  </medsurf-design-form-control-form>
}